import {
  Component, Inject, OnDestroy, OnInit,
} from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { MarkdownService } from '../../services/markdown.service';

@Component({
  selector: 'ut-custom-registration-landing',
  templateUrl: './custom-registration-landing.component.html',
  standalone: false,
})
export class CustomRegistrationLandingComponent implements OnInit, OnDestroy {
  customRegistration: any = null;
  currentUser: any = null;
  isLoggedInToPlatform: boolean = false;
  loading = true;
  introHtml: SafeHtml = '';
  infoSnippetHtml: SafeHtml = '';
  embeddedFormUrl: string = '';
  signupParams: any = {};

  constructor(
    private sanitizer: DomSanitizer,
    private markdownService: MarkdownService,
    @Inject('$transition$') private $transition$: any,
    @Inject('$state') private $state: any,
    @Inject('UserService') private UserService: any,
    @Inject('CustomRegistrationService') private CustomRegistrationService: any,
  ) { }

  ngOnInit(): void {
    document.body.classList.add('overflow-scroll');

    const { id } = this.$transition$.params();

    // Build signup params for unauthenticated users
    this.signupParams = this.getUtmParams();
    this.signupParams.customRegistrationId = id;

    Promise.all([
      this.CustomRegistrationService.find(id).then((response: any) => {
        if (response.data.registration_type === 'lite') {
          this.$state.go('signup');
          return;
        }

        this.customRegistration = response.data;

        if (this.customRegistration.intro) {
          this.introHtml = this.sanitizer.bypassSecurityTrustHtml(
            this.markdownService.process(this.customRegistration.intro),
          );
        }
        if (this.customRegistration.info_snippet) {
          this.infoSnippetHtml = this.sanitizer.bypassSecurityTrustHtml(
            this.markdownService.process(this.customRegistration.info_snippet),
          );
        }
      }).catch(() => {
        this.$state.go('signup');
      }),
      this.UserService.isPlatformLoggedIn().then((result: any) => {
        if (result && result.data === true) {
          this.isLoggedInToPlatform = true;
        }
      }),
      this.UserService.me().then((result: any) => {
        if (result !== null) {
          this.currentUser = result.data;
        }
      }),
    ]).finally(() => {
      this.loading = false;
      this.updateEmbeddedFormUrl();
    });
  }

  ngOnDestroy(): void {
    document.body.classList.remove('overflow-scroll');
  }

  private updateEmbeddedFormUrl(): void {
    if (this.customRegistration && this.currentUser) {
      const utmParams = this.getUtmParams();
      this.embeddedFormUrl = this.CustomRegistrationService.buildEmbeddedFormUrl(
        this.customRegistration.embedded_form,
        this.currentUser,
        utmParams,
      );
    }
  }

  private getUtmParams(): any {
    const params: any = {};
    const routeParams = this.$transition$.params();

    if (routeParams.utm_source) params.utm_source = routeParams.utm_source;
    if (routeParams.utm_medium) params.utm_medium = routeParams.utm_medium;
    if (routeParams.utm_campaign) params.utm_campaign = routeParams.utm_campaign;
    if (routeParams.utm_content) params.utm_content = routeParams.utm_content;
    if (routeParams.utm_term) params.utm_term = routeParams.utm_term;

    return params;
  }

  get currentUrl(): string {
    return encodeURIComponent(window.location.href);
  }
}

export default CustomRegistrationLandingComponent;

